
var $ccpurple = '#3b00d2';
var $ccpinkdark = '#b489d7';
var $ccpink = '#dcbaf7';
var $cckey = '#ff64bb';

var tourstyles = [
	{
		"elementType": "geometry",
		"stylers": [{ "color": $ccpink }]
	},
	{
		"elementType": "labels.icon",
		"stylers": [{ "visibility": "off" }]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [{ "color": $ccpurple }]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [{ "color": "white" }],
		"stylers": [{ "visibility": "off" }],
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{ "color": $ccpinkdark }]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{ "color": "#ffffff" }]
	}
]
